/**
 * Safely stringify any unknown value for logging without throwing.
 * - Handles circular references via a WeakSet.
 * - Falls back to Object.prototype.toString for non-serialisable values.
 */
export function safeStringify(value: unknown): string {
  if (typeof value === 'string') return value;
  try {
    const json = JSON.stringify(
      value,
      (() => {
        const seen = new WeakSet<object>();
        return (_key: string, val: unknown) => {
          if (typeof val === 'object' && val !== null) {
            if (seen.has(val as object)) return '[Circular]';
            seen.add(val as object);
          }
          return val as unknown;
        };
      })()
    );
    if (json === undefined) {
      // Top-level Symbol or unsupported type -> fallback
      return Object.prototype.toString.call(value);
    }
    return json;
  } catch (e) {
    try {
      return Object.prototype.toString.call(value);
    } catch {
      return '[Unserialisable]';
    }
  }
}
